import React, { FC, ReactElement } from 'react'
import { SettingsBlock } from './SettingsBlock'
import { Setting, SettingsT } from './types'
import { match } from './utils'

const settings: Setting[] = [
  {
    key: 'orderCompletionStatusAddedReadyForQcReview',
    title: 'A completed order has scanbacks and is ready for manual QC review',
    description: '',
    type: 'checkbox',
    values: [],
    options: [],
    previewImage: 'post_closing_reminder.png',
    dependencies: ['noco_concierge_flipper_enabled', 'post_closing_tools']
  },
  {
    key: 'orderQcPassed',
    title: 'QC is passed',
    description: '',
    type: 'checkbox',
    values: [],
    options: [],
    previewImage: '',
    dependencies: ['noco_concierge_flipper_enabled']
  },
  {
    key: 'orderQcErrorsFound',
    title: 'Errors are found',
    description: '',
    type: 'checkbox',
    values: [],
    options: [],
    previewImage: '',
    dependencies: ['noco_concierge_flipper_enabled']
  },
  {
    key: 'notaryAcknowledgesQcErrors',
    title: 'Notary acknowledges errors',
    description: '',
    type: 'checkbox',
    values: [],
    options: [],
    previewImage: '',
    dependencies: ['noco_concierge_flipper_enabled']
  }
]

export const QualityControlSettings: FC<SettingsT> = ({
  emailSettings,
  options,
  featurePolicies,
  notificationSettings,
  confirmBrowserExit
}): ReactElement => {
  return (
    <SettingsBlock
      id={emailSettings.id}
      companyId={emailSettings.companyId}
      title={'Quality control'}
      settings={match(settings, emailSettings, options)}
      featurePolicies={featurePolicies}
      notificationSettings={notificationSettings}
      confirmBrowserExit={confirmBrowserExit}
    />
  )
}
